import { Badge, Carousel, Col, Row } from "antd";
import React, { useState, useEffect } from 'react';
import { BsCameraReelsFill } from "react-icons/bs";
import {
  FaBiking,
  FaCamera,
  FaHeart,
  FaLocationArrow,
  FaPhoneSquare,
  FaStar,
  FaWhatsapp,
} from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { getAllBusiness, getHomeFeaturedBusiness } from "../../../utils/API";
import png1 from "../../../assets/frontendassets/Verification Icons/1.png";
import png2 from "../../../assets/frontendassets/Verification Icons/3.png"; 
import WebsiteSeo from "../Home/WebsiteSeo"
import { BiPhoneCall } from "react-icons/bi";
import business from "../Listing/business";
import trustedLogo from "../../../assets/frontendassets/Verification Icons/2.png";


const FeaturedListing = () => {
  const [slidesToShow, setSlidesToShow] = useState(2);
  const [businessdata, setBusinessData] = useState<any[]>([]);
  const imageUrl = process.env.REACT_APP_IMAGE_URL + '/businesse/';
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0); // Start with the middle business as active by default
  const [mobileNumber, setMobileNumber] = useState<string | null>(null);
  const [visibleNumbers, setVisibleNumbers] = useState<{ [key: string]: boolean }>({});
  const handleSlideChange = (current: any, next: number) => {
    if (next > current) {
      // Moving forward: highlight the next business
      setActiveIndex(next);
    } else if (next < current) {
      // Moving backward: highlight the previous business
      setActiveIndex(next);
    }
  };

  const handleGetBusiness = async () => {
    try {
      const res = await getHomeFeaturedBusiness();
      const filltredBusiness = res.data.filter((item: any) => item.isFeatured == 1);
      setBusinessData(filltredBusiness);
    } catch (error) {
      console.error("Failed to fetch business data", error);
    }
  };

  const handlenavigate = (slug: any) => {
    navigate(`/business/${slug}`);
  };


  useEffect(() => {
    handleGetBusiness();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setSlidesToShow(3);
      } else if (window.innerWidth >= 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const isBusinessOpen = (businessHours: any) => {
  
    if (!businessHours || !Array.isArray(businessHours)) {
      console.error("Invalid businessHours format", businessHours);
      return false;
    }
  
    const dayIndex = new Date().getDay(); // Get current day index (0 = Sunday, 1 = Monday, etc.)
    const daysMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const currentDayName = daysMap[dayIndex];
  
  
    const currentDay = businessHours.find((hour: any) => hour.name === currentDayName);
  
    if (!currentDay) {
      return false;
    }
  
    if (!currentDay.selected) {

      return false;
    }
  
    const now = new Date();
    const currentTime = now.getHours() * 100 + now.getMinutes(); // Convert current time to 24-hour format
  
    const openTime = parseInt(currentDay.openTime.replace(":", ""), 10);
    const closeTime = parseInt(currentDay.closeTime.replace(":", ""), 10);
  
    // Business open 24 hours scenario
    if (openTime === 0 && closeTime === 0) {
      return true;
    }
  
    // Handle cases where closing time extends past midnight
    if (closeTime < openTime) {
      return currentTime >= openTime || currentTime <= closeTime;
    }
  
    const isOpen = currentTime >= openTime && currentTime <= closeTime;
    return isOpen;
  };
  
  const handleToggleNumberVisibility = (slug: string) => {
    setVisibleNumbers((prevState) => ({
      ...prevState,
      [slug]: !prevState[slug],
    }));
  };
  const calculateBusinessAge = (createdAt: any) => {
    // console.log( 'createdAt', createdAt);
    const createdDate = new Date(createdAt);
    const currentDate = new Date();
    // console.log('createdDate', createdDate)
    const diffYears = currentDate.getFullYear() - createdDate.getFullYear();
    const diffMonths =
      currentDate.getMonth() - createdDate.getMonth() +
      diffYears * 12;
    // console.log('diffMonths', diffMonths)
    const years = Math.floor(diffMonths / 12);
    const months = diffMonths % 12;
    // console.log('gfgfgdg',years, months)
    return years > 0
      ? `${years} yrs${years > 1 ? "" : ""} ${months} mth${months > 1 ? "" : ""} in business`
      : `${months} mth${months > 1 ? "" : ""} in business`;
  };
  return (
    <>
      <WebsiteSeo />
     <Row className="md:pt-8 md:ps-8 md:px-18  xl:ps-18 xs:py-8 xxs:py-8 xs:px-3 xxs:px-3   sm:pt-12 sm:ps-12 sm:px-12 bg-[#FFF8EC]" justify={"center"}>
               <Col span={24}>
                 <div className="flex items-center justify-end pb-2">
                   <p style={{ letterSpacing: "1px" }} className="text-right text-black text-normal sm:text-sm md:text-[18px] lg:text-[18px] font-normal">
                    Local Businesses
                   </p>
                   <hr className="w-32 border-t-2 border-gray-400 ml-4" />
                 </div>
                 <div className="flex items-center justify-end">
                   <p className="text-right  text-3xl  text-black">
                     See Featured listings
                   </p>
                 </div>
               </Col>
             </Row>
      {
            businessdata.length > 0 ? (
              <>
              
      <Carousel
      autoplay
      autoplaySpeed={3000}
        infinite slidesToShow={slidesToShow} draggable dots={false} beforeChange={(current, next) => handleSlideChange(current, next)}
        className={`custom-carousel xs:p-3 xxs:p-3 md:pl-12 bg-[#FFF8EC] pb-12 md:pt-12 md:pr-12 md:pb-12 xl:pt-12 xl:pr-12 xs:pt-6 xs:ps-6 xs:px-6 xs:pl-6 sm:pt-4 sm:ps-4 sm:px-4 sm:pb-8 `}
      >
        {businessdata.map((listing: any, index: any, item: any) => {
          const isMiddleBusiness = activeIndex === index;
          return (
            <>
              <div key={index} className={`rounded overflow-visible  transition-transform duration-300 relative ${ // Added 'relative' to create a new stacking context
                isMiddleBusiness ? 'transform  scale-105 z-10 pl-3 pr-3' : 'pt-[11.5rem] pl-3 pr-3 pb-4 transform translate-y-2 scale-100'
                }`}
              >
                <div className="rounded overflow-hidden " >
                  <div className="relative">
                    <img className={`${isMiddleBusiness ? 'w-full rounded-xl mt-[2rem] object-fill' : 'object-fill w-full rounded-xl'}`} src={imageUrl + listing.galleryImage[0]} alt="Listing" style={{ height: "320px" }} />

                    <div className=" text-sm absolute top-0 right-0 text-white m-2 pt-1 pb-1 pr-2 pl-2 rounded-md flex flex-row items-center justify-center mt-3 ml-3 transition duration-500 ease-in-out">
                      <div
                        className={`absolute top-1 right-1 w-10 h-8 text-sm text-white rounded-md flex items-center justify-center mb-3  ${isBusinessOpen(listing.businessHours) ? 'bg-green-600' : 'bg-red-600'

                          }`}
                      >
                        <small className="font-bold">{isBusinessOpen(listing.businessHours) ? 'Open' : 'Closed'}</small>

                      </div>
                    
                    </div>
                 
                    <div className="hover:bg-white hover:text-black rounded-lg text-white bg-opacity-25 bg-black hover:animate-fade absolute top-[45%] w-full left-0 responsive-container">
                      <div className="hover:bg-[#FFF4E1] hover:text-black transition-colors duration-300 p-4 rounded-lg">
                        <Row className="d-flex mb-1" align={"middle"}>
                          <span className="text-sm rounded-md pl-1 pr-1 tracking-widest bg-green-500 text-white flex items-center mr-2">
                            <FaStar className="pr-1 text-yellow text-lg" />
                            <span className="text-[14px] font-semibold">
                              {listing.averageRating != null ? parseFloat(listing.averageRating).toFixed(1) : '0'}
                            </span>   
                          </span>
                                      <div className=" pl-2 items-center">
                  {/* {business.reviews.length} ratings  */}
<span className="ml-2  font-medium">
  {listing.reviews.length} ratings
</span>
</div>
                        </Row>
                        <div className="">
                          <div className="flex items-center space-x-3 ">
                            {item.isVerified === 2 && (
                              <div className="flex items-start space-x-1 pt-2">
                                <img src={png1} alt="logo" className="w-8 h-6" />
                              </div>
                            )}
                            {item.isTrusted === 2 && (
                              <div className="flex items-center space-x-1 pt-2">
                                <img src={png2} alt="logo" className="w-8 h-6" />
                              </div>
                            )}
                                {item.isPhysicallyVerified === 1 && (
                              <div className="flex items-center space-x-1 pt-2">
                                <img src={trustedLogo} alt="logo" className="w-8 h-6" />
                              </div>
                            )}
                            <div>
                            
                            </div>

                          </div>
                           <Row gutter={[8, 8]}>
                                       <Col
                                           xs={8}
                                           sm={8}
                                           md={5}
                                           lg={5}
                                           xl={5}
                                           xxl={5}
                                           className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                                         >
                                           <a href={`tel:${listing.mobileNumber}`} target="_blank" rel="noopener noreferrer">
                                             
                                           <button
                                             className="flex items-center justify-center space-x-1 px-1 py-1.5 rounded-md bg-[#118601] border-1 border-gray-900 text-white w-full text-md sm:text-md"
                                           >
                                             <BiPhoneCall className="text-[12px]" color="white" fill="white" />
                                             <span className="text-[12px]">call</span>
                                           </button>
                                           </a>
                                         </Col>
                                         <Col
                                           xs={8}
                                           sm={8}
                                           md={10}
                                           lg={10}
                                           xl={12}
                                           xxl={11}
                                           className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 md:ml-1 md:mr-1 w-auto"
                                         >
                                           <Link to={`/business/${listing.slug}`}>
                                           <button
                                             className="flex items-center justify-center space-x-2 px-2 py-1.5 rounded-md bg-[#FFE8C2] border-1 border-gray-900 text-black w-full text-md sm:text-md whitespace-nowrap"
                                           // onClick={handleEnquiryRedirect}
                                           >
                                             <FaStar className="text-yellow  text-[12px]" />
                                             <span className="truncate text-[12px]">Write Review</span>
                                           </button>
                                           </Link>
                                         </Col>
                                         <Col
                                           xs={8}
                                           sm={8}
                                           md={7}
                                           lg={7}
                                           xl={6}
                                           xxl={5}
                                           className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                                         >
                                           <Link to={`https://wa.me/${listing.whatsappNumber}?text=I'm interested in ${listing.businessName}`} target="_blank" rel="noopener noreferrer">
                                             
                                           <button
                                             className="flex items-center justify-center space-x-1 px-1 py-1.5 rounded-md bg-[#FFE8C2] border-1 border-gray-900 text-gray-700 w-full text-md sm:text-md"
                                           >
                                             <FaWhatsapp className="text-[12px]" color="green" fill="green" />
                                             <span className="text-[12px]">Chat</span>
                                           </button>
                                           </Link>
                                         </Col>
                                       </Row>


                          <Row className="d-flex align-items-start -mt-3 flex-column">
                            <Row className="w-full">
                              <Col xs={24} className="d-flex justify-start items-center mt-3">
                                <p className="font-bold">Address</p>
                              </Col>
                            </Row>
                            <Row className="w-full mt-1">
                              <Col xs={24} className="d-flex text-start">
                                <p
                                  className="hover:text-black whitespace-normal break-words max-w-full text-sm overflow-hidden"
                                  style={{
                                    lineHeight: '1.5rem', // Adjust line height for readability
                                    textOverflow: 'ellipsis', // Add ellipsis if content overflows
                                    whiteSpace: 'nowrap', // Prevent wrapping of text into multiple lines
                                  }}
                                >
                                  {`${listing.buildingName}, ${listing.streetName}, ${listing.city}, ${listing.state}, ${listing.pincode}`}
                                </p>
                              </Col>
                            </Row>
                          </Row>
                          <hr className="m-2 text-gray-500" style={{ width: "85%" }} />
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                {isMiddleBusiness && (
                  <div className="flex items-center justify-center space-x-3 ms-2 mt-4">
                    <div className="h-3 w-3 bg-[#757574] rounded-full"></div>
                    <div className="h-3 w-3 bg-[#757574] rounded-full"></div>
                    <div className="h-3 w-3 bg-[#757574] rounded-full"></div>
                  </div>

                )}

              </div>
            </>
          )
        }
        )}
        
      </Carousel>
      </> 
            ) : (
                <>
                  <div className="flex items-center justify-center space-x-3 ms-2 mt-4">
                      <p>No Business Found</p>
                    </div>
                </>
            )}
    </>
  );
};

export default FeaturedListing;
